import { render } from "./EditTypeService.vue?vue&type=template&id=2f8fb1e2&scoped=true"
import script from "./EditTypeService.vue?vue&type=script&lang=js"
export * from "./EditTypeService.vue?vue&type=script&lang=js"

import "./EditTypeService.vue?vue&type=style&index=0&id=2f8fb1e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8fb1e2"]])

export default __exports__